module.exports = __webpack_public_path__ + "static/media/printer-line.f87b53f8.svg";